import { render, staticRenderFns } from "./CatNicknameInputDialog.vue?vue&type=template&id=3378c249&scoped=true"
import script from "./CatNicknameInputDialog.vue?vue&type=script&lang=ts"
export * from "./CatNicknameInputDialog.vue?vue&type=script&lang=ts"
import style0 from "./CatNicknameInputDialog.vue?vue&type=style&index=0&id=3378c249&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3378c249",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3378c249')) {
      api.createRecord('3378c249', component.options)
    } else {
      api.reload('3378c249', component.options)
    }
    module.hot.accept("./CatNicknameInputDialog.vue?vue&type=template&id=3378c249&scoped=true", function () {
      api.rerender('3378c249', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/CatNicknameInputDialog.vue"
export default component.exports